import type { PokerGameTile } from '@ps/poker-games-tile-mappers';

import type { ScheduledTourn } from '@swf/generated/types/api/v0/SwHomeGames';

export const getUpcomingTournaments = (
  tournaments: PokerGameTile[],
  scheduled: ScheduledTourn[]
) => {
  const upcomingTournaments: PokerGameTile[] = [];

  scheduled.forEach((scheduled) => {
    const match = tournaments?.find(
      (tournament) => scheduled.tournId?.toString() === tournament.id
    );

    if (match) {
      return upcomingTournaments.push(match);
    }
  });

  return upcomingTournaments;
};
